import React from 'react';
import Skeleton from '../../../common/skeleton';

const personalInfoSkeleton = () => (
  <>
    <div className="personal-info-section">
      <div className="top-header-container">
        <div className="avarat-wrapper">
          <Skeleton count={1} circle width={64} height={64} />
        </div>
        <div className="title-age-container">
          <div className="my-profile-title">
            <Skeleton count={1} width={200} className={'mb-2'} />
          </div>
          <div className="my-profile-age">
            <Skeleton
              count={1}
              width={60}
              height={14}
              className={'form-label'}
            />
          </div>
        </div>
        <div className="my-profile-status">
          <div>
            <Skeleton count={1} width={70} height={16} className={'mb-2'} />
          </div>
          <div className="font-weight-bold">
            <Skeleton count={1} width={70} height={14} />
          </div>
        </div>
      </div>

      <div className="pt-2 member-details-container">
        <div className="first-column">
          <div>
            <label>
              <Skeleton
                count={1}
                width={130}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={85}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>

          <div>
            <label>
              <Skeleton
                count={1}
                width={95}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={110}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>

          <div>
            <label>
              <Skeleton
                count={1}
                width={60}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={45}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>

          <div>
            <label>
              <Skeleton
                count={1}
                width={110}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={140}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>

          <div>
            <label>
              <Skeleton
                count={1}
                width={90}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={140}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
        </div>

        <div className="second-column">
          <div>
            <label>
              <Skeleton
                count={1}
                width={130}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={85}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>

          <div>
            <label>
              <Skeleton
                count={1}
                width={95}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={110}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>

          <div>
            <label>
              <Skeleton
                count={1}
                width={60}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={45}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>

          <div>
            <label>
              <Skeleton
                count={1}
                width={110}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={140}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>

          <div>
            <label>
              <Skeleton
                count={1}
                width={90}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={140}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
        </div>
      </div>
    </div>

    <div className="contact-info-section">
      <div className="top-header-container"></div>
      <div className="pt-2 contact-container">
        <div className="first-column">
          <div>
            <label>
              <Skeleton
                count={1}
                width={130}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={85}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
          <div>
            <label>
              <Skeleton
                count={1}
                width={95}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={110}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
          <div>
            <label>
              <Skeleton
                count={1}
                width={60}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={45}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
          <div>
            <label>
              <Skeleton
                count={1}
                width={110}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={140}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
          <div>
            <label>
              <Skeleton
                count={1}
                width={90}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={140}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
        </div>

        <div className="second-column">
          <div>
            <label>
              <Skeleton
                count={1}
                width={130}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={85}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
          <div>
            <label>
              <Skeleton
                count={1}
                width={95}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={110}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
          <div>
            <label>
              <Skeleton
                count={1}
                width={60}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={45}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
          <div>
            <label>
              <Skeleton
                count={1}
                width={110}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={140}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
          <div>
            <label>
              <Skeleton
                count={1}
                width={90}
                height={14}
                className={'form-label'}
              />
            </label>
            <span className="plain-text ">
              <Skeleton
                count={1}
                width={140}
                height={14}
                className={'form-label'}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default personalInfoSkeleton;
